import {
  createContext,
  useContext,
  useState,
  useCallback,
  useMemo,
} from "react";

const LS_KEY = "777_theme";
const PageThemeCtx = createContext({ light: false, setLight: () => {} });

export function PageThemeProvider({ children }) {
  const [light, setLightState] = useState(() => {
    try {
      return localStorage.getItem(LS_KEY) === "true";
    } catch {
      return false;
    }
  });

  const setLight = useCallback((val) => {
    setLightState((prev) => {
      const next = typeof val === "function" ? val(prev) : val;
      try {
        localStorage.setItem(LS_KEY, next);
      } catch {
        /* ignore */
      }
      return next;
    });
  }, []);

  const value = useMemo(() => ({ light, setLight }), [light, setLight]);
  return (
    <PageThemeCtx.Provider value={value}>{children}</PageThemeCtx.Provider>
  );
}

export function usePageTheme() {
  return useContext(PageThemeCtx);
}
